import { combineReducers } from "redux";
import calendarReducer from "./Reducers/calendarReducer";
import courseReducer from "./Reducers/courseReducer";
import generalReducer from "./Reducers/generalReducer";
import linksReducer from "./Reducers/linksReducer";
import schedulerReducer from "./Reducers/schedulerReducer";
import socketReducer from "./Reducers/socketReducer";
import taskReducer from "./Reducers/taskReducer";
import timeslotReducer from "./Reducers/timeslotReducer";
import userReducer from "./Reducers/userReducer";

const rootReducer = combineReducers({
  general: generalReducer,
  user: userReducer,
  socket: socketReducer,
  tasks: taskReducer,
  courses: courseReducer,
  calendar: calendarReducer,
  links: linksReducer,
  timeslots: timeslotReducer,
  scheduler: schedulerReducer,
});
export default rootReducer;
